import React from 'react';
import styles from './Subquestion.module.css';
import Question from '../../../interfaces/question';
import QuestionFactory from '../utils/questionFactory';
import { formatQuestionTypeToClass } from '../../../utils/formatQuestionTypeToClass';

interface SubQuestionProps {
  question: Question;
}

const SubQuestion: React.FunctionComponent<SubQuestionProps> = ({ question }) => {
  const questionTypeClass = formatQuestionTypeToClass(question.type);
  const questionLabel = question.value;

  return (
    <div className={`${styles.multipleContainer} ${styles[questionTypeClass]}`}>
      {questionLabel && <p className={styles.questionLabel}>{question.value}</p>}
      <QuestionFactory question={question} />
    </div>
  );
};

SubQuestion.displayName = 'SubQuestion';

export default SubQuestion;
